import getIsPastStream from '@anm/helpers/stream/getIsPastStream';
import formatTime from '@anm/helpers/time/formatTime';
import { FC } from 'react';
import { DestinationStats, LiveStreamKind, LiveStreamStatus } from 'types/stream';

import { StreamTextItem } from '../../Wrapper';
import { DestinationWithStreamMeta } from '../../types';
import ProgressTime from '../ProgressTime';

import Wrapper from './Wrapper';
import { getCommentsText, getViewsText } from './helpers';

type StreamStatsProps = {
  kind: LiveStreamKind;
  state: LiveStreamStatus;
  destinations: DestinationWithStreamMeta[];
  lastStartedTime: number | null;
  duration?: number;
  startedAt?: number;
  webinarStats?: DestinationStats;
  pausedDuration?: number;
};

const StreamStats: FC<StreamStatsProps> = ({ state, kind, startedAt, duration, destinations, webinarStats,  ...rest }) => {
  const isPastStream = getIsPastStream(state);
  const canShowStats = (state !== 'SCHEDULED' && kind === 'LIVE') || (isPastStream && kind === 'HOSTED');

  return (
    <Wrapper>
      {state === 'INPROGRESS' && startedAt && <ProgressTime {...{ state, startedAt, ...rest }} />}
      {!['INPROGRESS', 'PAUSED', 'SCHEDULED'].includes(state) && !!duration && (
        <StreamTextItem variant="small-grey">{formatTime(duration)}</StreamTextItem>
      )}
      {canShowStats && <StreamTextItem variant="small-grey">{getViewsText(destinations, state, webinarStats)}</StreamTextItem>}
      {canShowStats && <StreamTextItem variant="small-grey">{getCommentsText(destinations, state, webinarStats)}</StreamTextItem>}
    </Wrapper>
  );
};

export default StreamStats;
